import clsx from 'clsx';
import { PropsWithChildren } from 'react';

export interface Props {
  className?: string;
}

export function Card({ className, children }: PropsWithChildren<Props>) {
  return (
    <div
      className={clsx(
        className,
        'rounded-lg border border-solid p-5',
        'border-gray-5 bg-gray-neutral-3',
        'th-highcontrast:border-white th-highcontrast:bg-black',
        'th-dark:border-legacy-grey-3 th-dark:bg-gray-iron-11'
      )}
    >
      {children}
    </div>
  );
}
